/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BonusHistoryEnumItem } from './BonusHistoryEnumItem';
import {
    BonusHistoryEnumItemFromJSON,
    BonusHistoryEnumItemFromJSONTyped,
    BonusHistoryEnumItemToJSON,
    BonusHistoryEnumItemToJSONTyped,
} from './BonusHistoryEnumItem';
import type { BonusHistoryItem } from './BonusHistoryItem';
import {
    BonusHistoryItemFromJSON,
    BonusHistoryItemFromJSONTyped,
    BonusHistoryItemToJSON,
    BonusHistoryItemToJSONTyped,
} from './BonusHistoryItem';

/**
 * 
 * @export
 * @interface BonusHistoryPageVo
 */
export interface BonusHistoryPageVo {
    /**
     * 当前页
     * @type {number}
     * @memberof BonusHistoryPageVo
     */
    currentPage?: number;
    /**
     * 总页数
     * @type {number}
     * @memberof BonusHistoryPageVo
     */
    totalPage?: number;
    /**
     * 总记录数
     * @type {number}
     * @memberof BonusHistoryPageVo
     */
    totalRecord?: number;
    /**
     * 流水列表
     * @type {Array<BonusHistoryItem>}
     * @memberof BonusHistoryPageVo
     */
    records?: Array<BonusHistoryItem>;
    /**
     * 使用区分枚举列表
     * @type {Array<BonusHistoryEnumItem>}
     * @memberof BonusHistoryPageVo
     */
    typeList?: Array<BonusHistoryEnumItem>;
}

/**
 * Check if a given object implements the BonusHistoryPageVo interface.
 */
export function instanceOfBonusHistoryPageVo(value: object): value is BonusHistoryPageVo {
    return true;
}

export function BonusHistoryPageVoFromJSON(json: any): BonusHistoryPageVo {
    return BonusHistoryPageVoFromJSONTyped(json, false);
}

export function BonusHistoryPageVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BonusHistoryPageVo {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalPage': json['totalPage'] == null ? undefined : json['totalPage'],
        'totalRecord': json['totalRecord'] == null ? undefined : json['totalRecord'],
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(BonusHistoryItemFromJSON)),
        'typeList': json['typeList'] == null ? undefined : ((json['typeList'] as Array<any>).map(BonusHistoryEnumItemFromJSON)),
    };
}

export function BonusHistoryPageVoToJSON(json: any): BonusHistoryPageVo {
    return BonusHistoryPageVoToJSONTyped(json, false);
}

export function BonusHistoryPageVoToJSONTyped(value?: BonusHistoryPageVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPage': value['currentPage'],
        'totalPage': value['totalPage'],
        'totalRecord': value['totalRecord'],
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(BonusHistoryItemToJSON)),
        'typeList': value['typeList'] == null ? undefined : ((value['typeList'] as Array<any>).map(BonusHistoryEnumItemToJSON)),
    };
}

